module.exports = __webpack_public_path__ + "media/cards/14-56347c71.png";